import { render } from "./MTView.vue?vue&type=template&id=04b48c3e"
import script from "./MTView.vue?vue&type=script&lang=js"
export * from "./MTView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/enforb/elena-front-deploy/elena-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__